module.exports = {
    YA_MEASUREMENT_ID: '22487215',
};
